var _path, _path2, _path3, _path4, _path5, _path6, _path7, _linearGradient, _path8, _defs, _path9, _path0, _path1, _circle, _defs2, _mask, _linearGradient2, _path10, _linearGradient3, _path11, _linearGradient4, _path12, _linearGradient5, _path13, _linearGradient6, _path14, _linearGradient7, _path15, _linearGradient8, _path16, _linearGradient9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _linearGradient0, _path24, _linearGradient1, _path25, _linearGradient10, _path26, _linearGradient11, _path27, _linearGradient12, _path28, _linearGradient13, _path29, _linearGradient14, _path30, _path31, _linearGradient15, _path32, _linearGradient16, _path33, _linearGradient17, _path34, _linearGradient18, _path35, _path36, _path37, _path38, _linearGradient19, _path39, _linearGradient20, _path40, _linearGradient21, _path41, _linearGradient22, _path42, _linearGradient23, _path43, _linearGradient24, _path44, _path45, _path46, _path47, _linearGradient25, _path48, _linearGradient26, _path49, _linearGradient27, _path50, _linearGradient28, _path51, _linearGradient29, _path52, _linearGradient30, _path53, _path54, _linearGradient31, _ellipse, _linearGradient32, _path55, _path56, _linearGradient33, _path57, _path58, _linearGradient34, _path59, _linearGradient35, _path60, _linearGradient36, _path61, _linearGradient37, _path62, _circle2, _linearGradient38, _path63, _linearGradient39, _path64, _linearGradient40, _path65, _linearGradient41, _path66, _path67, _path68, _linearGradient42, _path69, _path70, _path71, _path72, _path73, _linearGradient43, _path74, _linearGradient44, _path75, _linearGradient45, _path76, _text, _path77, _linearGradient46, _path78, _path79, _path80, _linearGradient47, _path81, _path82, _linearGradient48, _path83, _text2, _path84, _path85, _path86, _path87, _path88, _path89, _linearGradient49, _path90, _linearGradient50, _path91, _path92, _linearGradient51, _path93, _text3, _path94, _path95, _path96, _path97, _path98, _path99, _linearGradient52, _path100, _path101, _linearGradient53, _path102, _path103, _linearGradient54, _circle3, _text4, _path104, _path105, _linearGradient55, _path106, _path107, _linearGradient56, _path108, _path109, _linearGradient57, _path110, _path111, _linearGradient58, _path112, _path113;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomenWebDeveloperWithLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 800 600",
    viewBox: "0 0 800 600",
    id: "women-web-developer-with-laptop",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M111.86 449.42s-22.1-11.63-29.76-28.56-.18-40.65-2.48-48.61c14.14 14.95 22.83 19.29 29.01 36.54 6.18 17.24 4.39 35.78 3.23 40.63zM135.15 477.64s-22.75 18.03-46.69.62c-16.74-14.1-27.88-33.34-27.88-33.34s26.91 3.63 40.37 6.8c13.46 3.18 29.37 18.75 34.2 25.92zM704.07 449.42s22.1-11.63 29.76-28.56.18-40.65 2.48-48.61c-14.14 14.95-22.83 19.29-29.01 36.54-6.18 17.24-4.38 35.78-3.23 40.63zM680.78 477.64s22.75 18.03 46.69.62c16.74-14.1 27.88-33.34 27.88-33.34s-26.91 3.63-40.37 6.8c-13.46 3.18-29.37 18.75-34.2 25.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M220.07 544.46s-22.47 19.4-80.47 4.76c-42.27-10.67-77.1-52.41-77.1-52.41s82.98-31.42 157.57 47.65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M218.19 547.07s-44.68-5.2-87.78-84.93c-31.42-58.11-20.53-139.76-20.53-139.76s120.11 60.41 108.31 224.69z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M216.48 545.43s-35.54-27.58-31.16-118.1c3.19-65.98 54.77-130.21 54.77-130.21s71.51 113.85-23.61 248.31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M592.61 541.09s22.19 19.16 79.47 4.7c41.75-10.54 76.14-51.75 76.14-51.75S666.28 463 592.61 541.09z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M595.87 547.07s44.68-5.2 87.78-84.93c31.42-58.11 20.53-139.76 20.53-139.76s-120.11 60.41-108.31 224.69z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#741aac",
    d: "M597.58 545.43s35.54-27.58 31.16-118.1c-3.2-65.98-54.77-130.21-54.77-130.21s-71.51 113.85 23.61 248.31z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 409.947,
    x2: 409.947,
    y1: 4.696,
    y2: 547.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M711.33 311.78c0-166.45-134.93-301.38-301.38-301.38S108.57 145.33 108.57 311.78c0 94.95 43.92 179.62 112.54 234.86H598.8c68.6-55.24 112.53-139.91 112.53-234.86z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 381,
    height: 278,
    x: 220,
    y: 270,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M375.43 103.15c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19s.53-1.19 1.19-1.19c.66 0 1.19.54 1.19 1.19zM460.43 176.61c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19 0-.66.53-1.19 1.19-1.19.66 0 1.19.53 1.19 1.19zM318.86 194.89c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19 0-.66.53-1.19 1.19-1.19.66 0 1.19.53 1.19 1.19zM228.89 180.52c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19 0-.66.53-1.19 1.19-1.19.65 0 1.19.53 1.19 1.19zM577.48 252.89c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19s.53-1.19 1.19-1.19c.66 0 1.19.53 1.19 1.19z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#619fff",
    d: "m581.38 173.68 1.26 2.56 2.83.41-2.05 2 .49 2.82-2.53-1.33-2.54 1.33.49-2.82-2.05-2 2.83-.41z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#90c9ff",
    d: "m288.15 69.53 1.58 3.21 3.54.51-2.56 2.5.6 3.52-3.16-1.66-3.17 1.66.61-3.52-2.56-2.5 3.54-.51zM642.65 226.45l1.58 3.2 3.54.52-2.56 2.49.61 3.53-3.17-1.67-3.16 1.67.6-3.53-2.56-2.49 3.54-.52z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175.85,
    cy: 216.92,
    r: 4.19,
    fill: "#90c9ff"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 83.38,
    height: 83.37,
    x: 481.78,
    y: 56.83,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1,
    result: "back"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 83.38,
    height: 83.37,
    x: 481.78,
    y: 56.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 234.554,
    x2: 303.865,
    y1: 287.666,
    y2: 334.022,
    gradientTransform: "scale(-1 1) rotate(44.854 128.14 -754.315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M493.91 127.92c16.24 16.32 42.64 16.39 58.96.15 16.32-16.24 16.39-42.63.15-58.95-16.24-16.32-42.63-16.39-58.96-.15-16.31 16.23-16.38 42.62-.15 58.95z",
    mask: "url(#e)"
  })))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 234.554,
    x2: 303.865,
    y1: 287.666,
    y2: 334.022,
    gradientTransform: "scale(-1 1) rotate(44.854 128.14 -754.315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M493.91 127.92c16.24 16.32 42.64 16.39 58.96.15 16.32-16.24 16.39-42.63.15-58.95-16.24-16.32-42.63-16.39-58.96-.15-16.31 16.23-16.38 42.62-.15 58.95z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 939.678,
    x2: 773.04,
    y1: 282.213,
    y2: 193.009,
    gradientTransform: "scale(-1 1) rotate(6.794 -708.403 -12288.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M573.16 415.18c-.29-2.47 13.87-51.72 29.62-73.63 15.75-21.91 33.46-62.4 33.46-62.4s5.96 36.01-10.42 59.66-23.33 35.33-23.33 35.33 11.44-23.06 38.79-24.65c27.35-1.59 20.32 23.45 20.32 23.45s-30.18-43.14-92.82 54.45"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 506.161,
    x2: 614.271,
    y1: 497.927,
    y2: 318.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M535.73 462.95s-43 10.01-72.12-7.82c-29.11-17.82-48.2-43.11-48.2-43.11s32.53-10.95 53.5-6.61c20.97 4.33 39.32 28.06 39.37 26.15.05-1.92-22.37-32.26-24.19-52.22-1.82-19.97 7.66-57.36 7.66-57.36s27.61 21.27 34.49 37.91c6.88 16.64 12.23 52.55 12.23 52.55s-3.66-31.41 9.07-57.47 45.08-47.13 45.08-47.13 12.03 32.52 2.15 64.24c-9.88 31.72-32.76 52.58-32.76 52.58s31.66-22.85 51.2-25.98c19.54-3.13 46.64 13.84 46.64 13.84s-27.71 30.83-49.15 36.37c-21.43 5.54-42.98 2.7-42.98 2.7s29.73.51 47.22 12.35c17.49 11.83 32.39 36.25 32.39 36.25s-41.42 4.91-67.54-8.36c-26.12-13.28-44.06-28.88-44.06-28.88z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 634.726,
    x2: 634.562,
    y1: 534.088,
    y2: 534.889,
    gradientTransform: "rotate(18.924 848.543 304.954)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M576.67 452.23c-5.36-.57-8.95-.64-8.95-.64s3.46.44 8.95.64z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 558.873,
    x2: 574.841,
    y1: 423.079,
    y2: 423.079,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M498.02 344.96s5.27 69.65 38.05 106.95c-4.58-10.43-16.87-28.32-23.69-53.08-6.82-24.76-14.36-53.87-14.36-53.87z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 473.437,
    x2: 573.332,
    y1: 450.151,
    y2: 450.151,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M535.18 454.83s-61.64-17.86-85.46-28.95c-17.69-7.72-25.93-11.65-25.93-11.65s13.36 10.89 51.51 25.6c38.16 14.72 59.88 15 59.88 15z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 580.583,
    x2: 663.785,
    y1: 514.698,
    y2: 514.698,
    gradientTransform: "rotate(-12.552 430.484 641.862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M542.9 456.17s37.8 10.04 69.6 26.33c15.04 7.83 24.5 13.46 24.5 13.46s-25.8-11.56-43.57-18.61c-17.76-7.06-50.53-21.18-50.53-21.18z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 263.105,
    x2: 96.467,
    y1: 342.559,
    y2: 253.355,
    gradientTransform: "rotate(6.783 42.654 366.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M250.14 395.06c.29-2.47-13.87-51.72-29.62-73.63-15.75-21.91-33.46-62.4-33.46-62.4s-5.96 36.01 10.42 59.66 23.33 35.33 23.33 35.33-11.44-23.06-38.79-24.65c-27.35-1.59-20.32 23.45-20.32 23.45s30.18-43.14 92.82 54.45"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M550.67 288.47s-17.7 26.51-28.78 65.04c-11.08 38.53-6.68 81.77-6.68 81.77"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M544.29 332.66s-14.22 4.53-19.34 10.98c.16-7.09 2.32-32.77 2.32-32.77M535.28 373.79s-13.68 2.31-18.95 7.42c-3.29-7.67-6.35-27.66-6.35-27.66M522.8 408.88s-5.94 3.52-8.46 6.83c-4.45-6.69-16.25-19.18-16.25-19.18"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M548.51 290.94s17.41-.52 25-12.54 9.11-22.49 9.11-22.49-16.1 2.44-25.58 10.89c-9.48 8.45-8.53 24.14-8.53 24.14zM544.29 332.66s9.51-14.76 22.41-20.85c11.41-4.6 27.05 3.94 27.05 3.94s-1.89 11.64-19.35 18.22c-11.63 4.38-23.45 1.47-30.11-1.31zM510.87 357.05s6.09-24.76-5.32-34.52c-11.4-9.76-15.85-12.06-15.85-12.06s-4.53 19.15.47 29.5c5 10.33 20.7 17.08 20.7 17.08zM531.85 374.37s15.07-14.46 26.34-14.47c11.28-.02 22.96 5.03 22.96 5.03s-7.07 14.43-24.56 14.86c-17.5.42-24.74-5.42-24.74-5.42zM500.12 398.62s-3.07-19.17-17.43-22.97c-12.22-3.01-17.46-.19-17.46-.19s.59 9.38 7.78 17.23c7.2 7.84 27.11 5.93 27.11 5.93zM521.04 409.92s2.99-11.13 12.43-14.01c9.76-2.82 18.13 2.21 18.13 2.21s-1.22 11.62-12.16 14.29-18.4-2.49-18.4-2.49zM527.83 312.81s6.41-18.2 2.39-27c-4.02-8.81-12.84-12.72-12.84-12.72s-6.85 10.17-4.37 19.96c2.47 9.79 14.82 19.76 14.82 19.76z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M247.95 292.46s24.85 19.96 47 53.38 30.96 75.98 30.96 75.98"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.31,
    d: "M267.31 332.68s14.93.04 21.75 4.66c-2.28-6.72-12.06-30.56-12.06-30.56M288.27 369.2s13.75-1.91 20.3 1.38c.83-8.3-2.26-28.29-2.26-28.29M310.72 398.91s6.72 1.57 10.12 3.97c2.24-7.72 9.73-23.18 9.73-23.18"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M250.75 294.16s-16.77 4.74-27.61-4.45c-10.85-9.19-15.45-18.71-15.45-18.71s16.09-2.52 27.67 2.7c11.58 5.21 15.39 20.46 15.39 20.46zM267.31 332.68s-13.51-11.22-27.64-13.15c-12.27-.96-24.61 11.89-24.61 11.89s5.3 10.53 23.93 11.56c12.41.68 22.81-5.65 28.32-10.3zM306.52 345.89s-13.25-21.78-5.31-34.53c7.94-12.74 11.5-16.27 11.5-16.27s10.08 16.91 8.42 28.28c-1.67 11.37-14.61 22.52-14.61 22.52zM291.72 368.72s-18.72-9.26-29.48-5.88c-10.76 3.38-20.39 11.7-20.39 11.7s11.08 11.64 27.9 6.79c16.82-4.85 21.97-12.61 21.97-12.61zM329.28 382.31s-2.84-19.21 9.71-27.15c10.75-6.55 16.6-5.43 16.6-5.43s2.26 9.12-2.24 18.77c-4.51 9.65-24.07 13.81-24.07 13.81zM312.71 399.38s-6.2-9.72-16.06-9.63c-10.15.25-16.62 7.55-16.62 7.55s4.66 10.72 15.89 9.98c11.23-.74 16.79-7.9 16.79-7.9zM277.05 308.81s-11.58-15.43-10.4-25.04c1.18-9.61 8.43-15.99 8.43-15.99s9.59 7.64 10.17 17.72c.58 10.08-8.2 23.31-8.2 23.31z"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 481.058,
    x2: 578.279,
    y1: 566.473,
    y2: 412.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59023f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#590444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#5a0a53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#5c156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#5e238f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#6135bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#644cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6551ff"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M514.94 549.99s-37.16 23.84-70.57 16.81c-33.4-7.03-59.86-24.46-59.86-24.46s26.98-21.21 48.19-24.16c21.21-2.95 46.46 13.26 45.86 11.44-.6-1.82-31.89-22.89-40.3-41.09-8.41-18.2-12.01-56.61-12.01-56.61s33.14 10.79 45.2 24.16c12.06 13.37 29.14 45.41 29.14 45.41s-13.98-28.37-10.72-57.19c3.26-28.82 26.68-59.52 26.68-59.52s22.24 26.61 23.56 59.8c1.33 33.2-13.24 60.52-13.24 60.52s22.17-32.14 39.53-41.64 48.58-2.6 48.58-2.6-15.78 38.34-34.12 50.74c-18.34 12.41-39.59 16.95-39.59 16.95s28.18-9.48 48.63-4.2c20.45 5.29 42.67 23.3 42.67 23.3s-37.38 18.51-66.43 14.76c-29.07-3.74-51.2-12.42-51.2-12.42z"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 611.121,
    x2: 610.958,
    y1: 574.778,
    y2: 575.579,
    gradientTransform: "rotate(-.659 -3500.617 6255.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M549.91 526.16c-5.24 1.26-8.65 2.39-8.65 2.39s3.42-.73 8.65-2.39z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 517.537,
    x2: 533.504,
    y1: 446.413,
    y2: 446.413,
    gradientTransform: "rotate(-32.142 586.313 559.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M439.86 451.46s28.31 63.86 71.7 88.01c-7.81-8.3-25.39-21.03-40.11-42.07-14.73-21.04-31.59-45.94-31.59-45.94z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 432.096,
    x2: 531.994,
    y1: 473.485,
    y2: 473.485,
    gradientTransform: "rotate(-32.142 586.313 559.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M511.7 542.53s-64.06 3.84-90.22 1.37c-19.25-1.35-28.33-2.29-28.33-2.29s16.24 5.79 57.12 6.85c40.87 1.07 61.43-5.93 61.43-5.93z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 305.816,
    x2: 80.376,
    y1: 457.117,
    y2: 336.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M296.7 460.14s40.9-16.62 54.41-47.97c13.51-31.35 14.53-63.01 14.53-63.01s-32.89 9.81-47.52 25.45c-14.63 15.63-15.95 45.6-17.09 44.06-1.14-1.54-.32-39.25-10.35-56.62-10.03-17.36-39.33-42.45-39.33-42.45s-10.29 33.3-6.32 50.86c3.97 17.56 20.31 49.99 20.31 49.99s-15.12-27.78-40.55-41.73c-25.43-13.95-64.01-12.52-64.01-12.52s8.92 33.51 35.28 53.73S253.14 444 253.14 444s-39.04-.41-56.81 8.29c-17.77 8.71-30.13 38.2-30.13 38.2s40.42 9.21 61.13 1.38C248.04 484.04 264 469.3 264 469.3s-23.99 17.55-31.46 37.31c-7.47 19.76-5.56 48.29-5.56 48.29s36.67-19.87 50.36-45.77c13.7-25.9 19.36-48.99 19.36-48.99z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 371.665,
    x2: 371.502,
    y1: 907.176,
    y2: 907.977,
    gradientTransform: "scale(-1 1) rotate(54.134 480.815 70.715)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M257.07 474.98c4.06-3.55 6.94-5.68 6.94-5.68s-2.57 2.36-6.94 5.68z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 357.656,
    x2: 255.966,
    y1: 567.532,
    y2: 394.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59023f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#590444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#5a0a53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#5c156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#5e238f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#6135bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#644cf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6551ff"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M331.78 548.38s39.15 20.41 71.79 10.41c32.64-10 57.43-29.73 57.43-29.73s-28.77-18.71-50.16-19.74c-21.39-1.03-45.08 17.37-44.65 15.5.43-1.87 29.71-25.66 36.45-44.54 6.74-18.88 6.89-57.46 6.89-57.46s-32.04 13.72-42.86 28.12c-10.81 14.4-24.95 47.84-24.95 47.84s11.38-29.51 5.55-57.92c-5.83-28.41-31.9-56.89-31.9-56.89s-19.76 28.49-18.1 61.67c1.65 33.18 18.62 59.09 18.62 59.09s-24.96-30.02-43.1-37.93-48.62 1.77-48.62 1.77 19.15 36.77 38.53 47.48c19.37 10.71 40.95 13.33 40.95 13.33s-28.91-6.92-48.81.18c-19.89 7.1-40.4 27.03-40.4 27.03s38.89 15.08 67.49 8.75c28.59-6.32 49.85-16.96 49.85-16.96z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#00759f",
    d: "M315.37 383.98s26.07 28.48 31.9 56.89c5.83 28.41-5.55 57.92-5.55 57.92s14.14-33.45 24.95-47.84c10.81-14.4 42.86-28.12 42.86-28.12s-.14 38.58-6.89 57.46c-6.74 18.88-36.02 42.68-36.45 44.54-.43 1.87 23.26-16.54 44.65-15.5 21.39 1.03 50.16 19.74 50.16 19.74s-24.79 19.73-57.43 29.73-71.79-10.41-71.79-10.41l-1.05.51c3.31-72.44-15.36-164.92-15.36-164.92z",
    opacity: 0.3
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 235.804,
    x2: 235.641,
    y1: 809.65,
    y2: 810.451,
    gradientTransform: "scale(-1 1) rotate(4.485 3550.266 -6163.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#cec228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b2ae18"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M294.81 527.79c5.33.79 8.82 1.61 8.82 1.61s-3.46-.43-8.82-1.61z"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 75.122,
    x2: 91.094,
    y1: 450.292,
    y2: 450.292,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M397.72 443.52s-22.47 66.14-63.52 94.08c7.03-8.96 23.4-23.22 36.18-45.49 12.78-22.28 27.34-48.59 27.34-48.59z"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -10.319,
    x2: 89.584,
    y1: 477.367,
    y2: 477.367,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M334.34 540.66s64.15-1.92 89.98-6.72c19.05-3.07 28.01-4.82 28.01-4.82s-15.65 7.22-56.27 11.95c-40.62 4.73-61.72-.41-61.72-.41z"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 95.552,
    x2: 210.583,
    y1: 501.678,
    y2: 501.678,
    gradientTransform: "scale(-1 1) rotate(-26.996 -56.977 1408.051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M328.38 539.21s-24.21-25.12-46.73-41.56c-22.51-16.45-48.18-25.53-48.18-25.53s33.71 20.19 46.35 29.27c12.63 9.08 48.56 37.82 48.56 37.82z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M325.73 237.32s4.36 21.59-17.93 33.39c-7.46 2.58-21.36 2.83-29.09-4.55 11.34 5.51 21.44 6.43 28.9 3.52 4.24-3.53 16.42-8.15 18.12-32.36z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M313.79 239.55s4.87 18.47-6.28 30.7c-11.07-2.44-20.24-10.9-22.92-16.91 3.59 4.13 13.38 13.87 22.4 16.06 4.23-7.13 8.42-16.1 6.8-29.85z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M306.23 249.74s5.64 12.82 1.67 20.06c-2.11-1.23-12.28-10.44-15.16-24.52 4.22 7.86 5.71 14.87 14.53 22.48 1.13-4.82-.67-16.1-1.04-18.02z"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 321.755,
    x2: 331.407,
    y1: 176.067,
    y2: 176.067,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M326 242.01s3.24-1.9 3.59-6.76c.36-4.86-2.52-6.6-4.03-4.52-.65-1.47-1.31-.74-1.32.21-.91-.92-2.7-.97-2.93 1.15-.23 2.12 1.62 9.48 4.69 9.92z"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 312.21,
    x2: 320.754,
    y1: 183.315,
    y2: 183.315,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M314.1 243.33s3.69-2.32 2-7.75c-1.05-2.8-2.49-3.01-2.82-2.27-.41-.33-2.13-.59-2.22.89-.86-.46-2.35.77-1.94 2.49.39 1.72 1.34 5.8 4.98 6.64z"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 311.178,
    x2: 318.79,
    y1: 196.878,
    y2: 196.878,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M307.27 254.17s2.93-1.95 1.22-6.61c-1.09-3.16-2.63-2.1-2.65-1.43-.59-.89-1.59-.72-1.7.07-.86-.41-1.93.82-1.53 2.53.4 1.71 1.68 5.21 4.66 5.44z"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 294.66,
    x2: 305.468,
    y1: 197.055,
    y2: 197.055,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M294.4 249.66s2.82-1.35 2.05-5.7-3.17-7.1-4.05-5.35c-.87-.66-2.34-1.93-3.67.58-1.59.37-1.33 2.84-.63 4.65.69 1.8 3.27 5.95 6.3 5.82z"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 290.637,
    x2: 303.269,
    y1: 224.422,
    y2: 224.422,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M283.89 269.23s.84-3.02-2.94-5.3-7.43-2.29-6.7-.47c-1.07.22-2.99.49-1.98 3.15-.77 1.44 1.26 2.87 3.09 3.53 1.82.66 6.64 1.45 8.53-.91z"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 290.605,
    x2: 300.803,
    y1: 209.143,
    y2: 209.143,
    gradientTransform: "rotate(24.512 189.664 202.026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M287.02 256.26s1.36-1.38-.33-4.36c-1.1-2.23-4.52-5.99-5.06-3.1-1.59.03-3.41-.39-2.65 2.84-1.45.84-.16 2.37 1.31 3.86 1.48 1.48 5.3 1.99 6.73.76z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M308.52 268.42s.06.11.18.34c1.96 3.77 19.45 38.11 12.43 48.75.69-5.42-.16-12.2-4.96-25.87-4.8-13.67-9.17-22.25-9.17-22.25l1.59-.85M480.14 244.77s-4.36 21.59 17.93 33.39c7.46 2.58 21.36 2.83 29.09-4.55-11.34 5.51-21.44 6.43-28.9 3.52-4.24-3.53-16.42-8.15-18.12-32.36z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M492.08 247s-4.87 18.47 6.28 30.7c11.07-2.44 20.24-10.9 22.92-16.91-3.59 4.13-13.38 13.87-22.4 16.06-4.23-7.12-8.41-16.1-6.8-29.85z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M499.64 257.19s-5.64 12.82-1.67 20.06c2.11-1.23 12.28-10.44 15.16-24.52-4.22 7.86-5.71 14.87-14.53 22.48-1.13-4.82.67-16.1 1.04-18.02z"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 559.184,
    x2: 568.836,
    y1: 75.993,
    y2: 75.993,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M479.87 249.46s-3.24-1.9-3.59-6.76c-.36-4.86 2.52-6.6 4.03-4.52.65-1.47 1.31-.74 1.32.21.91-.92 2.7-.97 2.93 1.15.23 2.12-1.62 9.48-4.69 9.92z"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 549.64,
    x2: 558.183,
    y1: 83.241,
    y2: 83.241,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M491.77 250.78s-3.69-2.32-2-7.75c1.05-2.8 2.49-3.01 2.82-2.27.41-.33 2.13-.59 2.22.89.86-.46 2.35.77 1.94 2.49-.39 1.73-1.34 5.81-4.98 6.64z"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 548.608,
    x2: 556.22,
    y1: 96.804,
    y2: 96.804,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M498.6 261.62s-2.93-1.95-1.22-6.6c1.09-3.16 2.63-2.1 2.65-1.43.59-.89 1.59-.72 1.7.07.86-.41 1.93.82 1.53 2.53-.4 1.7-1.67 5.2-4.66 5.43z"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 532.089,
    x2: 542.898,
    y1: 96.98,
    y2: 96.98,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M511.48 257.11s-2.82-1.35-2.05-5.7 3.16-7.1 4.05-5.35c.87-.66 2.34-1.93 3.67.58 1.59.37 1.33 2.84.63 4.65-.7 1.8-3.28 5.95-6.3 5.82z"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 528.067,
    x2: 540.698,
    y1: 124.347,
    y2: 124.347,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M521.98 276.68s-.84-3.02 2.94-5.3 7.43-2.29 6.7-.47c1.07.22 2.99.49 1.98 3.15.77 1.44-1.26 2.87-3.09 3.53-1.82.66-6.64 1.45-8.53-.91z"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 528.034,
    x2: 538.232,
    y1: 109.068,
    y2: 109.068,
    gradientTransform: "scale(-1 1) rotate(24.512 -342.035 -2245.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M518.85 263.71s-1.36-1.38.33-4.36c1.1-2.23 4.52-5.99 5.06-3.1 1.59.03 3.41-.39 2.65 2.84 1.45.84.16 2.37-1.31 3.86-1.48 1.49-5.29 1.99-6.73.76z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M497.35 275.88s-.06.11-.18.34c-1.96 3.77-19.45 38.11-12.43 48.75-.69-5.42.16-12.2 4.96-25.87 4.8-13.67 9.17-22.25 9.17-22.25l-1.59-.85"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 415.485,
    x2: 415.485,
    y1: 615.037,
    y2: 544.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#6300b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#3800a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#190095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#07008e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.49,
    cy: 570.83,
    fill: "url(#L)",
    rx: 305.07,
    ry: 24.03
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 421.101,
    x2: 390.929,
    y1: 328.466,
    y2: 204.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "m399.61 238.71-33.52 57.83s41.07 36.04 48.61 32.69c7.54-3.35 44.42-17.6 44.42-17.6s.84-20.95-1.68-27.66c-2.51-6.7-33.52-55.31-36.04-53.64-2.52 1.68-21.79 8.38-21.79 8.38z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M270.8 499.03c1.68 1.12 14.81 19 32.97 31.57s42.74 24.86 42.74 24.86l136.89 2.23s30.73-13.13 49.73-29.33c19-16.2 23.19-28.5 23.19-28.5l-113.42 8.66-1.12-1.12-56.99.56"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 413.582,
    x2: 413.582,
    y1: 264.081,
    y2: 137.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M374.45 200.57s3.54 24.96 12.66 35.95 18.44 17.69 25.52 17.69c7.08 0 21.23-8.38 27.56-20.67s9.13-32.59 9.13-32.59 14.71-35.57-17.13-39.48c-31.85-3.91-49.73-10.06-52.15-2.79-2.42 7.25-5.59 41.89-5.59 41.89z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M434.05 170.58c.31-.5 15.09 23.47 13.41 36.69s-6.33 26.26-9.5 30.36c-3.17 4.1-11.73 11.17-11.73 11.17s-.75 18.81 6.52 28.5 20.86 15.83 27.01 16.39c6.15.56 11.73 1.3 11.17 1.3-.56 0-8.75-25.33-5.59-43.21 3.17-17.88-.74-68.35-7.64-87.16-6.89-18.81-11.36-20.3-11.36-20.3s-18.81-17.69-56.99-5.21c-22.04 7.2-27.01 32.03-26.82 59.04.19 27.01 2.98 48.61-4.47 69.66-7.45 21.05-5.96 27.38-5.96 27.38s28.31-.56 36.69-9.13c8.38-8.57 10.43-14.71 10.99-21.6.56-6.89 1.12-14.71 1.12-14.71s-14.16-8.01-19.37-23.47c-5.21-15.46-5.59-16.76-5.59-16.76s10.8-5.03 23.65-17.51c12.85-12.48 14.15-15.09 14.15-15.09l-8.75 13.78s16.95-.93 29.06-20.12z"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 343.072,
    x2: 329.662,
    y1: 304.562,
    y2: 435.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M366.63 293.97s-21.23 0-26.54 7.26c-5.31 7.26-36.32 94.15-34.92 99.73s49.17 68.17 49.17 68.17 1.4-33.8 1.12-35.48c-.28-1.68-25.7-39.39-25.7-40.23s24.31-44.98 24.31-44.98l12.56-54.47z"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 453.861,
    x2: 496.326,
    y1: 311.318,
    y2: 430.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M459.66 293.97s21.23 0 26.54 7.26 36.32 94.15 34.92 99.73-49.17 68.17-49.17 68.17-1.4-33.8-1.12-35.48c.28-1.68 25.7-39.39 25.7-40.23s-24.31-44.98-24.31-44.98l-12.56-54.47z"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 412.899,
    x2: 412.899,
    y1: 319.955,
    y2: 464.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dacff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#1b9fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#157dc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#0c4682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00002e"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M457.14 292.85s-12.57 18.16-41.63 19.56c-29.05 1.4-44.14-19-44.14-19l-4.75.56s-11.73 25.14-12.85 42.18c-1.12 17.04 1.96 24.86 6.15 32.97s7.82 8.94 7.82 8.94l1.68 114.54s77.66 8.38 77.39 7.54c-.28-.84 15.64-121.25 15.64-122.36 0-1.12 9.22-19.84 9.78-33.52s-8.94-49.73-8.94-49.73l-6.15-1.68z"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 414.425,
    x2: 414.425,
    y1: 512.534,
    y2: 365.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#0a0b14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#151a2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#252d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#3a477d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#5466b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#728af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7790ff"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M335.62 510.2s-12.57-114.82-12.29-115.94c.28-1.12-1.12-5.59 14.53-5.31 15.64.28 159.8 0 159.8 0s8.66-1.68 7.82 9.78c-.84 11.45-6.15 106.72-6.15 106.72l-163.71 4.75z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.44,
    cy: 442.88,
    r: 12.01,
    fill: "#fff",
    opacity: 0.3
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 251.642,
    x2: 435.817,
    y1: 504.749,
    y2: 504.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#190c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000054"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M434.98 530.04c-.52-1.8-35.48-17.32-45.26-25.42-9.78-8.1-38.27-24.31-61.46-32.69-23.19-8.38-43.3-18.16-48.05-19.56-4.75-1.4-13.69-2.51-22.35 8.94s-7.82 20.95-.28 28.5c7.54 7.54 36.88 33.25 63.42 40.79s45.54 11.45 66.21 17.32c20.67 5.87 33.52 10.06 33.52 10.06s19.28-10.62 14.25-27.94z"
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 423.618,
    x2: 523.441,
    y1: 562.617,
    y2: 562.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M423.62 556.58s9.5.84 12.57 3.07c3.07 2.23 8.94 5.59 12.01 5.59 3.07 0 13.97 1.68 21.51 5.03 7.54 3.35 24.31 12.85 28.22 11.17l3.91-1.68s2.79 0 4.47-1.4c1.68-1.4 1.96-2.79 1.96-2.79s3.07 0 4.47-1.4 1.4-3.91 1.4-3.91 2.51.28 3.35-1.4l.84-1.68s3.07-1.96 4.19-4.19c1.12-2.23 1.12-2.51.56-3.35-.56-.84-11.73-8.38-14.25-8.38-2.51 0-14.81-1.4-21.51-3.35-6.7-1.96-11.17-2.51-24.03-4.19-12.85-1.67-39.67 12.86-39.67 12.86z"
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 397.638,
    x2: 581.813,
    y1: 505.867,
    y2: 505.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#190c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000054"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M398.48 531.16c.52-1.8 35.48-17.32 45.26-25.42 9.78-8.1 38.27-24.31 61.46-32.69 23.19-8.38 43.3-18.16 48.05-19.56 4.75-1.4 13.69-2.51 22.35 8.94s7.82 20.95.28 28.5c-7.54 7.54-36.88 33.25-63.42 40.79-26.54 7.54-45.54 11.45-66.21 17.32-20.67 5.87-33.52 10.06-33.52 10.06s-19.28-10.62-14.25-27.94z"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 407.747,
    x2: 263.006,
    y1: 535.424,
    y2: 590.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#eff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#dae9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#bdd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#98c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6ba9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#378aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M398.1 532.83s-30.92 15.27-36.32 15.27-6.71-1.86-9.31-2.98c-2.61-1.12-7.64-.56-14.9 2.79-7.26 3.35-12.48 6.33-17.32 5.96-4.84-.37-14.71-3.35-20.3-.56s-16.02 12.85-12.29 16.76c3.73 3.91 13.41 8.2 17.51 5.96 4.1-2.23 15.46-2.79 24.77-1.86 9.31.93 19.74 3.91 27.01 1.3s20.11-10.06 31.1-12.85c10.99-2.79 22.16-4.84 22.16-4.84s-14.53-7.25-12.11-24.95z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M505.52 397.07c-.09-9.61-7.87-8.12-7.87-8.12s-144.15.28-159.8 0c-15.64-.28-14.25 4.19-14.53 5.31-.02.09.03.86.15 2.2 1.3-1.86 2.89-4.99 11.92-4.99h161.29s5.69-.28 8.84 5.6z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m606.57 574.41-38.06-174.47-4.43.63 2.56 11.75c.67.74-17.03 0-17.03 0l-2.69-12.35-4.56.04 38.25 175.34a2.233 2.233 0 0 0 2.66 1.71 2.24 2.24 0 0 0 1.71-2.66l-2.8-12.85h17.03l3.01 13.8c.26 1.21 1.45 1.97 2.66 1.71s1.95-1.44 1.69-2.65zm-56.13-158.27h17.03l2.69 12.35h-17.03l-2.69-12.35zm3.53 16.16H571l2.7 12.35h-17.03l-2.7-12.35zm3.52 16.16h17.03l2.69 12.35h-17.03l-2.69-12.35zm3.53 16.15h17.03l2.69 12.35h-17.03l-2.69-12.35zm3.52 16.16h17.03l2.69 12.35h-17.03l-2.69-12.35zm3.53 16.16h17.03l2.69 12.35h-17.03l-2.69-12.35zm3.52 16.16h17.03l2.69 12.35h-17.03l-2.69-12.35zm3.53 16.16h17.03l2.69 12.35h-17.03l-2.69-12.35zm6.22 28.51-2.69-12.35h17.03l2.69 12.35h-17.03z"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 564.059,
    x2: 610.275,
    y1: 389.772,
    y2: 469.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#de5f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopColor: "#b5615a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#906286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#7163ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5864ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#4565e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#3766f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#2f66fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c66ff"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M582.04 415.07c.03.06.41 7.6-3.98 6.87-2.47-.41-3.58-10.48-8.1-17.36-1.06-1.61-4.88-12.49-5.69-14.16-1.3-2.7 3.1-3.23 4.09-2.1.78.89 2.87 5.17 6.39 11.04 3.99 6.61 6.52 13.78 7.29 15.71z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M583.9 498.18c-1.99-.95-6.53-2.24-7.27-4.75-.02-.07-.02-.13-.04-.2-.57-2.32 1.19-2.67 3.19-2.25 2.05.43 8.08 1.54 8.08 1.54s1.06 2.5 1.06 3.98c0 1.5-3.06 2.62-5.02 1.68z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m587.67 491.22.16 1.1c.06.43-.15.86-.54 1.06-.68.33-1.85.73-3.3.49-.44-.08-.79-.43-.86-.87l-.2-1.39 4.74-.39z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M579.64 514.79c-2.25-1.07-7.41-2.54-8.24-5.39-.03-.08-.02-.15-.04-.22-.64-2.63 1.35-3.03 3.62-2.56 2.33.49 9.17 1.75 9.17 1.75s1.23 2.87 1.23 5.01c-.01 2.14-3.52 2.47-5.74 1.41z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m583.92 506.89.18 1.24c.53 1.78-2.71 2.03-4.35 1.75-.5-.09-.9-.48-.97-.99l-.23-1.58 5.37-.42z"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 580.94,
    x2: 578.186,
    y1: 454.719,
    y2: 503.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#403372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#3e3677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#374086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#2b519f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#1c68c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#0885ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M588.97 449.63s1.21 3.84 1.54 8.51c.41 5.86-5 12.08-4.5 15.91.9 6.89 2.84 14.09 3.04 16.15.2 2.07-7.17 3.25-7.71 1.02s-5.85-13.72-6.42-16.99c-.99-5.63 5.97-8.22 5.97-8.22s-.7 15.92.16 20.64c.49 2.68 3.61 17.81 3.95 19.81.09.55-.91 2.1-2.88 2.45-2.09.37-4.54-.19-4.87-1.03-.85-2.2-3.86-18.56-4.33-21.11-.48-2.55-1.87-26.73-2.28-28.52-.42-1.8 17.51-10.44 18.33-8.62z"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 546.879,
    x2: 593.096,
    y1: 386,
    y2: 465.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#fc5e03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f45e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#e55f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#d06038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b66159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#956280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#6f63af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#4365e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c66ff"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M565.81 423.34c-.04 7 4.33 35.61 5.22 35.92 5.58 1.92 19.13-6.22 18.95-8.42-1.19-14.41-5.89-35.71-8.73-36.41-5.97-1.49-15.42 5.48-15.44 8.91z"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 541.968,
    x2: 576.298,
    y1: 370.424,
    y2: 370.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M576.3 370.42c0 9.48-7.68 17.17-17.17 17.17-9.48 0-17.16-7.69-17.16-17.17s7.68-17.16 17.16-17.16 17.17 7.68 17.17 17.16z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#431ca3",
    fontFamily: "MyriadPro-Bold",
    fontSize: 12.67,
    transform: "translate(547.276 376.03)"
  }, "PHP")), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a477",
    d: "M554.01 449.38c-.85.54-1.33 1.12-1.93 2.02-.9 1.29 1 5.19 2.19 4.09-.24-1.22 1.54-1.81 2.18-2.12 2.11-1 2.32-2.03 2.18-2.83-.39-2.19-1.98-2.84-4.62-1.16z"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 559.375,
    x2: 576.767,
    y1: 451.253,
    y2: 417.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#fb5e04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f15f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#df5f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c76044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#a7616a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#806399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#5464cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c66ff"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M565.02 440.45c-.17 2.48-7.03 5.89-8.07 7.44-.95 1.42-.13 3.51 2.53 3.32 1.35-.14 12.61-6.26 12.86-8.57.45-4.19.55-22.42-4.62-21.92-4.42.42-2.52 17.25-2.7 19.73z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a477",
    d: "M576.18 404c-.7-4.77-4.56-6.69-9.48-4.56-5.88 2.56-3.49 7.2-3.12 9.23.47 2.62 1.59 7.78 3.05 8.18 1.05.29 1.8-.19 2.9-.56.38 1.41.33 2.18.56 2.37 1.07.89 6.23-1.47 6.03-3.18-.09-.78-.24-2.07-.33-3.35-.38-3.36.97-4.23.39-8.13z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078a2",
    d: "M569.27 407.74c-.9-.37-1.8.14-2.18 1.99-.03.14-.93.49-.91.22.63-6.3-2.27-4.52-2.91-5.55-.03-2.79 1.01-4.93 4.08-5.87 4.99-1.53 9.86.67 10.56 5.45.48 3.27-1.77 5.51-1.65 8.78.02.45-.29.32-1.24.55-.74.18-1.6 1-2.36.86-.95-.18-3.04-2.1-2.79-3.36.24-1.15.32-2.69-.6-3.07z"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 580.729,
    x2: 583.543,
    y1: 475.156,
    y2: 475.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#100060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090e96"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M582.5 491.8s-1.95-12.32-1.76-14.97c.19-2.65.92-16.64.92-16.64l1.88-1.68s-1.86 15.59-1.62 20.19.58 13.1.58 13.1z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a477",
    d: "M563.87 388.89c-.44-.78.01-3.64.7-5.41.74-1.91 2.06-5.73 3.11-5.25.66.3-.24 3.21-.24 6.31 0 1.97-.53 3.88-.86 4.76-.24.66-2.11.75-2.71-.41z"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: -6.381,
    x2: -31.208,
    y1: 367.299,
    y2: 321.193,
    gradientTransform: "matrix(-1 0 0 1 276.51 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M314.58 347.9c0-11.73-9.51-21.24-21.24-21.24-11.73 0-21.24 9.51-21.24 21.24 0 11.73 9.51 21.24 21.24 21.24 11.73.01 21.24-9.5 21.24-21.24z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#125cae",
    fontFamily: "MyriadPro-Bold",
    fontSize: 17.406,
    transform: "translate(274.01 353.264)"
  }, "CSS3")), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M280.35 451.86s-.06 1.03-.09 1.9c-.01.23-.01.45-.01.64 0 .27 1.38.49 2.51.18.89-.24 1.66-.93 1.3-1.34-.38-.42-.77-1.9-.77-1.9l-2.94.52z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M280.27 453.76s2.07.9 3.8-.52c.93-.04 8.83 1.69 8.04 2.95-.8 1.28-11.03 1.8-11.93 1.12-.35-.26-.27-2.68.09-3.55z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebbeaf",
    d: "M263.81 449.69s-.18 1.01-.3 1.87c-.03.23-.06.44-.08.64-.03.27 1.32.64 2.48.46.91-.14 1.76-.74 1.44-1.19-.33-.46-.56-1.97-.56-1.97l-2.98.19z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m277.76 408.82-6.91-2.81c-.49 7.12.2 12.77-1.81 23.51-.85 4.52-4.99 15.04-6.6 20.19.47 1.1 5.13 1.23 5.77.08.83-1.76 6.26-11.77 7.75-18.17.68-2.96 1.83-15.64 1.8-22.8zM263.51 451.57s1.95 1.13 3.83-.09c.93.06 8.6 1.59 7.75 3.27-.34.67-11.24 1.12-12.06.35-.31-.31.04-2.7.48-3.53z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M273.48 376.16s.61-2.05.45-3.06c-.16-1.01-2.43-2.39-2.79-4.5-.36-2.11.86-4.94 4.02-5.16 4.77-.34 4.62 3.39 4.79 4.68.28 2.09.06 5.42-.42 5.65-.14.07-.73.14-1.76-.21-.18.52-.64 2.95-.29 3.7.35.75-4-1.1-4-1.1z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M271.09 401.45c-.24 1.56-.4 3.28-.25 4.57.76 6.19 5.35 13.95 6.91 24.28.69 4.55 1.03 16.92 1.23 21.73.59 1.05 5.23.65 5.74-.55-.51-2.26 1.83-17.42 1.17-25.11-.28-3.29-5.09-26.19-5.09-26.19s-6.51-.57-9.71 1.27z"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 1253.161,
    x2: 1261.105,
    y1: 314.902,
    y2: 283.896,
    gradientTransform: "rotate(-8.969 1383.481 6602.967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#eb3300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f80"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M277.92 376.44s-2.96-1.92-5.37-1.54c-.34.22-.45 1.27-.91 2.54-.5 1.39-1.34 3.08-1.54 4.99-.34 3.35.3 12.44-.33 20.89.99 1.59 8.64 4.04 12.68.45 0 0-1.05-5.19-1.29-9.39-.25-4.35 2.7-4.81 2.14-8.24-.36-2.2-4.38-4.81-5.47-8.12-.14-.44.17-1.09.09-1.58z"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 1255.28,
    x2: 1267.689,
    y1: 281.138,
    y2: 254.549,
    gradientTransform: "rotate(-8.969 1383.481 6602.967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#2f1109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#7a3e25"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M279.65 363.88c1.57 3.57-3.26 3.38-4.51 9.82-.81 4.16-5.2 5.58-5.04 11.86-2.76-.54-3.94-5.06-1.01-10.21 1.88-3.3.35-6.68.88-9.31 1.06-5.23 8.2-5.51 9.68-2.16z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M273.4 382.33c.29-2.28 2.48-2.18 6.37-2.82 1.82-.3 5.17-.98 7.75-1.87 1.05-.36 2.58-10.84 2.73-13.66.06-1.22-.82-1.49-1.36-2.51-.53-1.01-.85-2.73-.31-2.9.4-.13.72 1.42 1.02 1.49-.11-1.2-.45-3.03.02-4.23.47-1.2 2.21-.43 2.62-.04.5.47.65 1.22.74 2.3.12 1.29.59 3.01.18 3.88-.35.76-.68 1.79-.67 2.33.01.54-.14 15.66-1.48 16.55-1.82 1.21-6.88 2.79-11.55 3.6-3.7.63-6.29-.33-6.06-2.12z"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 650.5,
    x2: 606.705,
    y1: 497.21,
    y2: 455.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M600.62 475.05c0-14.62 11.85-26.47 26.47-26.47s26.47 11.85 26.47 26.47-11.85 26.47-26.47 26.47c-14.62-.01-26.47-11.86-26.47-26.47z"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#731ba3",
    fontFamily: "MyriadPro-Bold",
    fontSize: 19.958,
    transform: "translate(605.441 481.498)"
  }, "Java")), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m654.03 451.15 2.53.95c.82.31 1.47.96 1.78 1.78l1.21 3.24c.45 1.21.53 2.53.23 3.78-.41 1.71-1.23 3.28-2.37 4.61 5.24.73 9.46.84 14.6-.04-1.36-4.25-2.4-7.95-5.36-11.31l-1.12-1.33c.39-.07 1.37-8.96.17-11.01-2.34-4-7.09-3.16-8.45-2.22-1.97 1.59-1.52 3.45-2.27 4.2-.83.84-1.52.87-1.56 1.21-.04.34.41.65.55.87-.17 1.68-.86 3.02-.83 4.06.02.43.47 1.05.89 1.21z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#f58f9e",
    d: "m658.34 453.88.56 1.5c-.48-2.45 1.36-3.59 1.36-3.59-.01 0-.93.33-2.42.24-.72-.04-1.78-.28-2.3-.42-.52-.15-1.27-.37-1.27-.37l2.29.86c.82.3 1.47.95 1.78 1.78z",
    opacity: 0.35
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M693.88 550.19s1.01 1.28 3.16 2.64c2.1 1.32 4.2 2.62 3.89 3.24-.31.62-5.32 7.94-8.25 9.63-2.93 1.7-.42-1.49-.26-2.26.16-.77 1.65-4.44.42-6.14-1.23-1.69-2.7-2.7-2.31-3.47.38-.77 2.31-4.16 3.35-3.64z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M672.42 503.18s-.47 20.6 2 24.3c2.47 3.7 17.62 16.75 20.91 23.32 0 0-2.05 4.93-5.75 4.73 0 0-8.49-9.97-14.74-13.7-5.33-3.18-8.48-5.92-9.61-8.7-1.13-2.78-9.56-28.98-9.56-28.98l16.75-.97zM697.98 553.42s.64 1.72-1.25 2.87c-1.6.97-4.15.78-4.02 2.41.14 1.79-.35 4.83-1.79 6.59-1.05 1.29-4.08 3.73-3.4 4.33.49.44 5.4 1.25 10.76-4.01 5.63-5.53 5.8-8.41 5.55-9-.35-.75-2.96-2.79-5.85-3.19z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M652.23 560s.08 4.32-.31 5.39c-.39 1.08-9.32.92-11.33-.77-2-1.7 4.78-2.08 6.09-3.4.59-.59 1.25-2.23 1.25-2.23l4.3 1.01z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M671.8 491.21s2.32 6 1.98 10.34c-.65 8.38-11.43 26.34-12.67 30.04-1.23 3.7 1.34 9.45-1.13 15.41-2.47 5.96-6.78 13.56-6.88 13.97-.1.41-5.22.94-6.33-1.68 1.09-3.54 3.05-10.22 3.77-16.29.72-6.06 1.93-13.92 2.14-17.72.21-3.8 5.06-33.47 5.06-33.47s2.04.32 14.06-.6zM652.2 562.8s-.59 2.59-3.16 1.92c-2.57-.67-1.54-2.32-2.41-2.99-.54-.42-1.82-.16-4.64.47-3.58.8-9.3 1.17-9.31 3.19 0 .98 4.37 3.33 9.59 3.9 5.22.57 10.31-.51 10.87-.82.58-.31.15-4.05-.94-5.67z"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 316.542,
    x2: 321.946,
    y1: 500.379,
    y2: 456.627,
    gradientTransform: "translate(345.057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M659.23 460.81c.73-2.78 4.25-4.94 7.37-4.25 2.55.56 5.61 5.57 6.12 9.48.51 3.9-1.92 21.11.77 27.43 0 0-13.68 4.34-19.02 2.53 0 0 1.67-6.07 2.19-10.64.97-8.55-2.6-9.52-2.49-14.21.08-2.95 4.49-8.18 5.06-10.34z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M665.91 462.68c2.03-.39 3.76 1.42 4.52 6.75.96 6.69 1.99 16.39 1.41 19.44-.33 1.7-10.78-.48-20.1-3.67-1.43-.49-3.39 1.18-4.72 1.07-2.59-.22-6.63-1.43-6-2.83.37-.83 3.04-1.3 2.9-1.41l-3.27-1.23c.08-.8 1.85-.55 3.63-.88 2.62-.47 4.91.01 7.48.98 1.83.69 10.53 2.54 13.9 1.92-.54-3.76-1.26-8.39-1.64-10.79-.87-5.56-1.36-8.72 1.89-9.35z"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 321.33,
    x2: 322.322,
    y1: 460.548,
    y2: 474.899,
    gradientTransform: "translate(345.057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M663.23 472.55c2.17-.48 4.35-.65 6.58-.8.51-.03 1.01-.07 1.52-.1-.09-.82-.19-1.62-.3-2.37-.76-5.33-3.22-8.41-5.29-7.74-3.11 1.01-3.46 4.95-2.6 10.5.03.16.06.33.09.51z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M664.9 437.36c-4.14-1.52-7.17 1.17-7.64 2.23 3.15.39.9 3.65 3.21 5.4 2.14 1.62 1.13 4.04 1.56 8.27.7 6.82 8.93 5.46 10.46 11.57 3.08-7.93-4.51-11.66-3.66-16.88.87-5.36-.5-9.33-3.93-10.59z"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 219.334,
    x2: 262.076,
    y1: 485.371,
    y2: 439.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88cfda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#89cfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#c8d9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#f0dfa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1a0"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.47,
    cy: 460.42,
    r: 26.71,
    fill: "url(#ai)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fill: "#431ca3",
    fontFamily: "MyriadPro-Bold",
    fontSize: 21.155,
    transform: "matrix(.6795 0 0 1 219.526 467.587)"
  }, "HTML5")), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#684204",
    d: "m218.43 437.87-2.85 1.06c-.93.35-1.66 1.08-2 2l-1.36 3.64a7.29 7.29 0 0 0-.26 4.26c.46 1.92 1.38 3.7 2.67 5.2-5.91.82-10.66.95-16.45-.05 1.53-4.79 2.7-8.96 6.03-12.74l1.26-1.5c-.44-.08-1.55-10.09-.2-12.41 2.63-4.51 7.98-3.56 9.52-2.5 2.22 1.79 1.71 3.88 2.56 4.73.94.94 1.72.98 1.76 1.36.05.38-.46.74-.62.98.19 1.89.97 3.4.93 4.57-.01.52-.51 1.22-.99 1.4z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M173.54 549.43s-1.14 1.44-3.56 2.97c-2.36 1.49-4.73 2.95-4.39 3.65.35.69 5.99 8.94 9.29 10.85 3.3 1.91.47-1.68.3-2.55-.17-.87-1.86-5.01-.47-6.92 1.39-1.91 3.04-3.04 2.6-3.91-.43-.85-2.6-4.67-3.77-4.09z"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 739.95,
    x2: 784.627,
    y1: 525.963,
    y2: 525.963,
    gradientTransform: "matrix(-1 0 0 1 956.533 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3113c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#2f18c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#2927cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#1f40d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#1263e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#008fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M197.71 496.47s.53 23.21-2.25 27.38c-2.78 4.17-19.85 18.87-23.55 26.27 0 0 2.31 5.55 6.48 5.32 0 0 9.56-11.23 16.6-15.43 6-3.58 9.55-6.67 10.83-9.8 1.27-3.13 10.76-32.64 10.76-32.64l-18.87-1.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M168.92 553.08s-.72 1.94 1.41 3.24c1.8 1.1 4.68.88 4.53 2.72-.16 2.01.39 5.45 2.02 7.43 1.19 1.45 4.6 4.2 3.83 4.88-.55.49-6.08 1.41-12.11-4.51-6.35-6.23-6.54-9.48-6.25-10.13.38-.9 3.32-3.19 6.57-3.63zM220.46 560.48s-.09 4.86.35 6.08c.43 1.22 10.5 1.04 12.76-.87 2.26-1.91-5.38-2.35-6.86-3.82-.66-.66-1.4-2.51-1.4-2.51l-4.85 1.12z"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 754.292,
    x2: 742.265,
    y1: 474.085,
    y2: 536.054,
    gradientTransform: "matrix(-1 0 0 1 956.533 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7633ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#7137ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#6243ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#4957ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#2672ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ff"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M198.41 482.99s-2.61 6.76-2.23 11.65c.73 9.44 12.88 29.67 14.27 33.84 1.39 4.17-1.5 10.65 1.27 17.36 2.78 6.71 7.64 15.28 7.76 15.74.12.46 5.89 1.05 7.12-1.9-1.22-3.99-3.43-11.52-4.24-18.35-.81-6.83-2.18-15.68-2.41-19.96-.23-4.28-5.7-37.7-5.7-37.7s-2.3.36-15.84-.68z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M220.49 563.64s.67 2.92 3.56 2.17 1.74-2.62 2.71-3.36c.61-.47 2.05-.18 5.22.53 4.03.9 10.48 1.32 10.48 3.59 0 1.11-4.92 3.76-10.8 4.39-5.88.64-11.61-.58-12.25-.93-.63-.35-.14-4.56 1.08-6.39z"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 746.627,
    x2: 752.715,
    y1: 493.322,
    y2: 444.035,
    gradientTransform: "matrix(-1 0 0 1 956.533 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#eb3300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f80"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M212.57 448.75c-.82-3.13-4.79-5.56-8.31-4.79-2.88.63-6.32 6.27-6.9 10.67-.58 4.4 2.16 23.78-.87 30.9 0 0 15.4 4.89 21.42 2.85 0 0-1.89-6.84-2.47-11.98-1.09-9.63 2.93-10.72 2.8-16.01-.06-3.32-5.03-9.21-5.67-11.64z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#684204",
    d: "M205.05 450.86c-2.28-.44-4.23 1.6-5.09 7.6-1.08 7.53-2.24 18.46-1.58 21.89.37 1.92 12.14-.54 22.65-4.13 1.61-.55 3.81 1.33 5.32 1.2 2.91-.25 7.46-1.61 6.76-3.19-.42-.94-3.42-1.47-3.26-1.59l3.69-1.38c-.09-.9-2.08-.62-4.09-.99-2.95-.53-5.54.01-8.43 1.1-2.06.78-11.86 2.86-15.65 2.16.61-4.23 1.42-9.45 1.84-12.15.95-6.25 1.5-9.82-2.16-10.52z"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 752.022,
    x2: 753.139,
    y1: 448.453,
    y2: 464.62,
    gradientTransform: "matrix(-1 0 0 1 956.533 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#fc5e03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f45e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#e55f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#d06038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b66159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#956280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#6f63af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#4365e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c66ff"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M208.06 461.97c-2.44-.55-4.9-.74-7.41-.91l-1.71-.12c.11-.92.22-1.82.34-2.67.86-6 3.63-9.47 5.96-8.71 3.5 1.14 3.9 5.57 2.93 11.83-.03.18-.07.38-.11.58z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M206.19 422.33c4.67-1.71 8.07 1.32 8.6 2.51-3.54.43-1.02 4.11-3.61 6.08-2.41 1.82-1.27 4.55-1.76 9.32-.79 7.68-10.07 6.15-11.78 13.03-3.47-8.93 5.08-13.14 4.13-19.01-.99-6.04.56-10.51 4.42-11.93z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomenWebDeveloperWithLaptop);
export default __webpack_public_path__ + "static/media/women-web-developer-with-laptop.3566d18d9e1a265fd8e17b8009bd37d9.svg";
export { ForwardRef as ReactComponent };